module.exports = __webpack_public_path__ + "img/refunds.296aa810.png";